export default {
    data() {
        return {
            alert: { alerts: [], type: "error" },
            form: { alert: { alerts: [], type: "error" } },
            indexSelected: null,
            itemSelected: null
        }
    },
    methods: {

        // getModelDefault() {
        //     return {}
        // },

        // async newItem(modelDefault) {
        //     console.log("aquiiiiiiiiiii");
        //     if (modelDefault != null) {

        //         this.edit(modelDefault);

        //     } else {
        //         let obj = await this.getModelDefault();
        //         this.edit(obj)
        //     }
        // },
        cancel() {
            this.clear();
        },

        clear() {
            this.itemSelected = null;
            this.indexSelected = null;
        },

        confirm(noDialog, formIsValid) {
            if (!formIsValid) return;
            if (this.indexSelected == null || this.indexSelected < 0) {
                if (!this.value) {
                    this.$emit('input', [this.itemSelected]);
                } else {
                    this.value.push(this.itemSelected);
                    this.$emit('input', this.value);
                }
            }
            else {
                this.value[this.indexSelected] = this.itemSelected;
                this.$emit('input', this.value);
            }

            if (!noDialog)
                this.$refs['dialogRef'].open();

            this.clear();

        },
        async remove(index) {
            if (!(await this.$confirm())) return;
            this.value.splice(index, 1);
            this.clear();
        },
        
        edit(item, index, noDialog, duplicate) {
            this.indexSelected = index >= 0 ? index : null;

            if(duplicate === true){
                var json = localStorage.getItem("duplicateStage");
                var objectCopy = JSON.parse(json);
                this.indexSelected = null;
                var model = this.getEmptyModel();
                console.log("objeto", objectCopy);

                objectCopy.jobStageItemProds.map((item) => {
                    item.qtReal = 0;
                })

                model.jobStageItemProds = objectCopy.jobStageItemProds;
                model.jobStageItemConss = objectCopy.jobStageItemConss;
                this.itemSelected = model;
                localStorage.removeItem('duplicateStage');
            } else if(item != null && !duplicate) {

                if (typeof item === "string") {
                    this.itemSelected = item.toString();

                } else {
                    this.indexSelected = index;
                    let obj = {};
                    Object.assign(obj, item);
                    this.itemSelected = obj;
                }
            } else {
                this.itemSelected = null;
            }

            this.$forceUpdate();

            if (!noDialog)
                this.$refs['dialogRef'].open();
        },

        getEmptyModel() {
            return {
                description: "",
                stages: [],
                jobStageItemProds: [],
                jobStageItemConss: [],
                jobId: null,
            };
        },

        duplicateStage(model, index, noDialog) {
            let newModel = this.getEmptyModel();
            newModel.jobStageItemConss = this.itemSelected.jobStageItemConss;
            newModel.jobStageItemProds = this.itemSelected.jobStageItemProds;
            this.itemSelected = null;
            this.indexSelected = -1;
            if (newModel != null) {

                if (typeof newModel === "string") {
                    this.itemSelected = newModel.toString();

                } else {
                    let obj = {};
                    Object.assign(obj, newModel);
                    this.itemSelected = obj;
                }
            } else {
                this.itemSelected = null;
            }

            console.log("item", this.itemSelected);
            console.log("index", this.indexSelected);

            this.value.push(this.itemSelected);
            this.$emit('confirm');

            // this.modelStage = null;
            // this.modelStage = this.itemSelected;
            // this.$emit("input", this.itemSelected);

            if (!noDialog)
                this.$refs['dialogRef'].open();
        }
    },

}